import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { RcReportView, reportFor } from '@elva/ui';
import { useClearPageTopBarActions } from '@/app/layouts/pageTopBar';
import { usePeriodRange } from '@/app/hooks/usePeriodRange';

/**
 * A recall's report (amendment 22 §4).
 *
 * **Each report shows its own recall.** This page used to be handed
 * `RECALL_CAMPAIGNS.report` whatever id it was opened with, so every Report was
 * the Hygiene report — it is derived from the row now, and an id with no row
 * goes back to the list rather than rendering somebody else's numbers.
 */
export function RecallReportPage() {
  useClearPageTopBarActions();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [period, setPeriod] = usePeriodRange();
  const data = id === undefined ? undefined : reportFor(id, period);
  if (data === undefined) return <Navigate to="/recall" replace />;
  return (
    <RcReportView
      data={data}
      period={period}
      onPeriodChange={setPeriod}
      onBack={() => { void navigate('/recall'); }}
      onSetup={() => { void navigate(`/recall/${id ?? ''}/audience`); }}
      onChangeSequence={() => { void navigate(`/recall/${id ?? ''}/messages`); }}
    />
  );
}
